import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'

import VueShowdown from 'vue-showdown'
import ZoomOnHover from "vue-zoom-on-hover";

Vue.use(ZoomOnHover);

// the second parameter of Vue.use() is optional
Vue.use(VueShowdown, {
    // set default flavor of showdown
    flavor: 'github',
    // set default options of showdown (will override the flavor options)
    options: {
        emoji: false,
    },
})
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.config.productionTip = false

import './custom.scss'

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
